import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import TitleBar from "../_common/TitleBar";
import Table from "../_common/Table";
import moment from "moment";
import reportsTitleBarMenu from "../_titleBarMenus/reportsTitleBarMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "reactstrap";
import jsonToCsv from "../../_utils/jsonToCsv";
import "./reports.css";
// import { actionScripts } from "../../_helpers/actionScripts";

class WorkPerformedReport extends Component {
  state = {
    remarks: "",
    lwpColumns: [],
    ewpColumns: [],
    lwpCsvColumns: [],
    ewpCsvColumns: [],
    lwpSortColumn: { path: "date", order: "asc" },
    ewpSortColumn: { path: "date", order: "asc" },
    openSections: ["labor", "equip"],
  };

  componentDidMount() {
    const {
      projContractorList,
      projItemList,
      projCcoList,
      projPendingIssueList,
      projLaborList,
    } = this.props;

    this.setState({
      lwpColumns: [
        {
          label: "Date",
          path: "date",
          content: (lwp) => moment(lwp.date).format("MM/DD/YYYY"),
        },
        {
          label: "Contractor",
          path: "contractorName",
          content: (lwp) => {
            const ctr = (projContractorList || []).find(
              (c) => c.contractorId === lwp.contractorId
            );
            if (ctr) return ctr.name;
            return "";
          },
        },
        { label: "Labor Name", path: "laborFullName" },
        { label: "Trade", path: "laborTrade" },
        {
          label: "Work Perf. On",
          path: "wpFullCaption",
          content: (lwp) => {
            if (lwp.isBidItem) {
              const bi = (projItemList || []).find((i) => i.bidItemId === lwp.bidItemId);
              if (bi) return bi.itemFullCaption;
            } else if (lwp.isCco) {
              const co = (projCcoList || []).find((c) => c.ccoId === lwp.ccoId);
              if (co) return co.ccoFullCaption;
            } else if (lwp.isPendingIssue) {
              const pi = (projPendingIssueList || []).find(
                (pi) => pi.pendingIssueId === lwp.pendingIssueId
              );
              if (pi) return pi.pendingIssueFullCaption;
            }
            return "(N/A)";
          },
        },
        { label: "Reg Hrs", path: "regHours" },
        { label: "OT Hrs", path: "otHours" },
      ],
      ewpColumns: [
        {
          label: "Date",
          path: "date",
          content: (ewp) => moment(ewp.date).format("MM/DD/YYYY"),
        },
        {
          label: "Contractor",
          path: "contractorName",
          content: (ewp) => {
            const ctr = (projContractorList || []).find(
              (c) => c.contractorId === ewp.contractorId
            );
            if (ctr) return ctr.name;
            return "";
          },
        },
        { label: "Eq No.", path: "number" },
        { label: "Class", path: "class" },
        { label: "Make", path: "make" },
        { label: "Eq. Desc.", path: "description" },
        {
          label: "Operator",
          path: "operator",
          content: (ewp) => {
            if (ewp.operatorId) {
              const op = (projLaborList || []).find((l) => l.laborId === ewp.operatorId);
              if (op) return op.fullName;
            }
            return "";
          },
        },
        {
          label: "Item #",
          path: "bidItemNo",
          content: (ewp) => {
            if (ewp.isBidItem) {
              const bi = (projItemList || []).find((i) => i.bidItemId === ewp.bidItemId);
              if (bi) return bi.itemNo;
            }
            return "";
          },
        },
        {
          label: "CCO #",
          path: "ccoNo",
          content: (ewp) => {
            if (ewp.isCco) {
              const co = (projCcoList || []).find((c) => c.ccoId === ewp.ccoId);
              if (co) return co.ccoNo;
            }
            return "";
          },
        },
        {
          label: "PI #",
          path: "pendingIssueNo",
          content: (ewp) => {
            if (ewp.isPendingIssue) {
              const pi = (projPendingIssueList || []).find(
                (pi) => pi.pendingIssueId === ewp.pendingIssueId
              );
              if (pi) return pi.pendingIssueNo;
            }
            return "";
          },
        },
        {
          label: "Description",
          path: "wpDescription",
          content: (ewp) => {
            if (ewp.isBidItem) {
              const bi = (projItemList || []).find((i) => i.bidItemId === ewp.bidItemId);
              if (bi) return bi.description;
            } else if (ewp.isCco) {
              const co = (projCcoList || []).find((c) => c.ccoId === ewp.ccoId);
              if (co) return co.description;
            } else if (ewp.isPendingIssue) {
              const pi = (projPendingIssueList || []).find(
                (pi) => pi.pendingIssueId === ewp.pendingIssueId
              );
              if (pi) return pi.description;
            }
            return "(N/A)";
          },
        },
        { label: "Reg Hrs", path: "regHours" },
        { label: "OT Hrs", path: "otHours" },
      ],
      lwpCsvColumns: [
        {
          label: "Date",
          path: "date",
          content: (lwp) => moment(lwp.date).format("MM/DD/YYYY"),
        },
        {
          label: "Contractor",
          path: "contractorName",
          content: (lwp) => {
            const ctr = (projContractorList || []).find(
              (c) => c.contractorId === lwp.contractorId
            );
            if (ctr) return ctr.name;
            return "";
          },
        },
        { label: "Labor Name", path: "laborFullName" },
        { label: "Trade", path: "laborTrade" },
        {
          label: "Item #",
          path: "bidItemNo",
          content: (lwp) => {
            if (lwp.isBidItem) {
              const bi = (projItemList || []).find((i) => i.bidItemId === lwp.bidItemId);
              if (bi) return bi.itemNo;
            }
            return "0";
          },
        },
        {
          label: "CCO #",
          path: "ccoNo",
          content: (lwp) => {
            if (lwp.isCco) {
              const co = (projCcoList || []).find((c) => c.ccoId === lwp.ccoId);
              if (co) return co.ccoNo;
            }
            return "0";
          },
        },
        {
          label: "PI #",
          path: "pendingIssueNo",
          content: (lwp) => {
            if (lwp.isPendingIssue) {
              const pi = (projPendingIssueList || []).find(
                (pi) => pi.pendingIssueId === lwp.pendingIssueId
              );
              if (pi) return pi.pendingIssueNo;
            }
            return "0";
          },
        },
        {
          label: "Description",
          path: "wpDescription",
          content: (lwp) => {
            if (lwp.isBidItem) {
              const bi = (projItemList || []).find((i) => i.bidItemId === lwp.bidItemId);
              if (bi) return bi.description;
            } else if (lwp.isCco) {
              const co = (projCcoList || []).find((c) => c.ccoId === lwp.ccoId);
              if (co) return co.description;
            } else if (lwp.isPendingIssue) {
              const pi = (projPendingIssueList || []).find(
                (pi) => pi.pendingIssueId === lwp.pendingIssueId
              );
              if (pi) return pi.description;
            }
            return "(N/A)";
          },
        },
        { label: "Reg Hrs", path: "regHours" },
        { label: "OT Hrs", path: "otHours" },
      ],
      ewpCsvColumns: [
        {
          label: "Date",
          path: "date",
          content: (ewp) => moment(ewp.date).format("MM/DD/YYYY"),
        },
        {
          label: "Contractor",
          path: "contractorName",
          content: (ewp) => {
            const ctr = (projContractorList || []).find(
              (c) => c.contractorId === ewp.contractorId
            );
            if (ctr) return ctr.name;
            return "";
          },
        },
        { label: "Eq No.", path: "number" },
        { label: "Class", path: "class" },
        { label: "Make", path: "make" },
        { label: "Eq. Desc.", path: "description" },
        {
          label: "Operator",
          path: "operator",
          content: (ewp) => {
            if (ewp.operatorId) {
              const op = (projLaborList || []).find((l) => l.laborId === ewp.operatorId);
              if (op) return op.fullName;
            }
            return "";
          },
        },
        {
          label: "Item #",
          path: "bidItemNo",
          content: (ewp) => {
            if (ewp.isBidItem) {
              const bi = (projItemList || []).find((i) => i.bidItemId === ewp.bidItemId);
              if (bi) return bi.itemNo;
            }
            return "";
          },
        },
        {
          label: "CCO #",
          path: "ccoNo",
          content: (ewp) => {
            if (ewp.isCco) {
              const co = (projCcoList || []).find((c) => c.ccoId === ewp.ccoId);
              if (co) return co.ccoNo;
            }
            return "";
          },
        },
        {
          label: "PI #",
          path: "pendingIssueNo",
          content: (ewp) => {
            if (ewp.isPendingIssue) {
              const pi = (projPendingIssueList || []).find(
                (pi) => pi.pendingIssueId === ewp.pendingIssueId
              );
              if (pi) return pi.pendingIssueNo;
            }
            return "";
          },
        },
        {
          label: "Description",
          path: "wpDescription",
          content: (ewp) => {
            if (ewp.isBidItem) {
              const bi = (projItemList || []).find((i) => i.bidItemId === ewp.bidItemId);
              if (bi) return bi.description;
            } else if (ewp.isCco) {
              const co = (projCcoList || []).find((c) => c.ccoId === ewp.ccoId);
              if (co) return co.description;
            } else if (ewp.isPendingIssue) {
              const pi = (projPendingIssueList || []).find(
                (pi) => pi.pendingIssueId === ewp.pendingIssueId
              );
              if (pi) return pi.description;
            }
            return "(N/A)";
          },
        },
        { label: "Reg Hrs", path: "regHours" },
        { label: "OT Hrs", path: "otHours" },
      ],
    });
  }

  toggleSection = (section) => (e) => {
    e.preventDefault();
    let openSections = [...this.state.openSections];
    if (openSections.includes(section))
      openSections = openSections.filter((os) => os !== section);
    else openSections.push(section);
    this.setState({ openSections });
  };

  handleTitleBarAction = (action) => () => {
    switch (action) {
      case "saveQuery":
        break;
      case "pdf":
        break;
      default:
        break;
    }
  };

  handleChange_remarks = (e) => this.setState({ remarks: e.target.value });

  handleSort_lwp = (lwpSortColumn) => this.setState({ lwpSortColumn });

  handleSort_ewp = (ewpSortColumn) => this.setState({ ewpSortColumn });

  handleClick_tr_lwp = () => {};

  handleClick_tr_ewp = () => {};

  handleClick_csv = (section) => (e) => {
    e.preventDefault();
    switch (section) {
      case "labor": {
        const { lwpCsvColumns } = this.state;
        const rawData = this.getLwpData();
        const data = rawData.map((row) => {
          let mappedRow = {};
          for (let c = 0; c < lwpCsvColumns.length; c++) {
            if (lwpCsvColumns[c].content)
              mappedRow[lwpCsvColumns[c].label] = lwpCsvColumns[c].content(row);
            else if (lwpCsvColumns[c].path in row)
              mappedRow[lwpCsvColumns[c].label] = row[lwpCsvColumns[c].path];
          }
          return mappedRow;
        });
        jsonToCsv(data, "Title", true);
        break;
      }
      case "equip": {
        const { ewpCsvColumns } = this.state;
        const rawData = this.getEwpData();
        const data = rawData.map((row) => {
          let mappedRow = {};
          for (let c = 0; c < ewpCsvColumns.length; c++) {
            if (ewpCsvColumns[c].content)
              mappedRow[ewpCsvColumns[c].label] = ewpCsvColumns[c].content(row);
            else if (ewpCsvColumns[c].path in row)
              mappedRow[ewpCsvColumns[c].label] = row[ewpCsvColumns[c].path];
          }
          return mappedRow;
        });
        jsonToCsv(data, "Title", true);
        break;
      }
      default:
        break;
    }
  };

  getLwpData = () => {
    const { lwpSortColumn } = this.state;
    const { report } = this.props;
    return _.orderBy(
      report.laborWorkPerformedReportData,
      [lwpSortColumn.path],
      [lwpSortColumn.order]
    );
  };

  getEwpData = () => {
    const { ewpSortColumn } = this.state;
    const { report } = this.props;
    return _.orderBy(
      report.equipmentWorkPerformedReportData,
      [ewpSortColumn.path],
      [ewpSortColumn.order]
    );
  };

  getParamCaption = (queryBy, qcParam) => {
    const {
      projItemList,
      projCcoList,
      projPendingIssueList,
      projLaborList,
      projEquipList,
      projContractorList,
    } = this.props;
    let fullCap = "";
    switch (queryBy) {
      case "ITEM": {
        const item = (projItemList || []).find((i) => i.bidItemId === qcParam);
        if (item) fullCap = `[${item.itemFullCaption}]`;
        break;
      }
      case "CCO": {
        const cco = (projCcoList || []).find((c) => c.ccoId === qcParam);
        if (cco) fullCap = `[${cco.ccoFullCaption}]`;
        break;
      }
      case "PENDINGISSUE": {
        const pi = (projPendingIssueList || []).find(
          (pi) => pi.pendingIssueId === qcParam
        );
        if (pi) fullCap = `[${pi.pendingIssueFullCaption}]`;
        break;
      }
      case "LABOR": {
        const lab = (projLaborList || []).find((l) => l.laborId === qcParam);
        if (lab) fullCap = `[${lab.fullName}]`;
        break;
      }
      case "EQUIPMENT": {
        const eq = (projEquipList || []).find((eq) => eq.equipmentId === qcParam);
        if (eq) fullCap = `[${eq.numberMakeDesc}]`;
        break;
      }
      case "CONTRACTOR": {
        const ctr = (projContractorList || []).find((c) => c.contractorId === qcParam);
        if (ctr) fullCap = `[${ctr.name}]`;
        break;
      }
      default:
        break;
    }
    return fullCap;
  };

  renderQueryParams = (qc) => {
    return qc.params.map((qcp, paramIndex) => {
      const fullCap = this.getParamCaption(qc.queryBy, qcp);
      if (paramIndex < qc.params.length - 1) return fullCap + ",";
      return fullCap;
    });
  };

  render() {
    const { lwpColumns, ewpColumns, lwpSortColumn, ewpSortColumn, openSections } =
      this.state;
    const { report, fetching } = this.props;
    const lwpData = report.laborWorkPerformedReportData ? this.getLwpData() : [];
    const ewpData = report.equipmentWorkPerformedReportData ? this.getEwpData() : [];
    return (
      <React.Fragment>
        <TitleBar
          titleText={"Labor and Equipment Hours"}
          menu={reportsTitleBarMenu}
          disabledActions={{ saveQuery: fetching, csv: fetching, pdf: fetching }}
          handleTitleBarAction={this.handleTitleBarAction}
        />
        <div className="card mx-2">
          <div className="card-body">
            <h3>Labor and Equipment Hours</h3>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Report Created On:</label>
              <div className="col-sm-3">
                <input
                  type="text"
                  disabled
                  className="form-control"
                  value={moment(report.createdOn).format("MM/DD/YYYY HH:mm")}
                />
              </div>
            </div>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Report Created By:</label>
              <div className="col-sm-3">
                <input
                  type="input"
                  disabled
                  className="form-control"
                  value={report.createdBy}
                />
              </div>
            </div>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Remarks:</label>
              <div className="col-sm-5">
                <textarea
                  className="form-control"
                  rows={3}
                  onChange={this.handleChange_remarks}
                />
              </div>
            </div>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Provided Criteria:</label>
              <div className="col-sm-9">
                <div className="card">
                  <div className="card-body p-3">
                    {report.queryParams &&
                      report.queryParams.criteria &&
                      report.queryParams.criteria
                        .filter((qc) => qc.params && qc.params.length > 0)
                        .map((qc, index) => (
                          <div className="row" key={`faHrsRptQueryParamKey_${index}`}>
                            <div className="col">
                              <span className="mr-2">
                                <b>{qc.queryByLabel}</b> containing ANY of:
                              </span>
                              {this.renderQueryParams(qc)}
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-2">
              <div className="card-body">
                <p className="h4 mb-0">
                  <span onClick={this.toggleSection("labor")} className="pointer-cursor">
                    {openSections.includes("labor") ? (
                      <FontAwesomeIcon icon="caret-down" className="fa-fw mr-2" />
                    ) : (
                      <FontAwesomeIcon icon="caret-right" className="fa-fw mr-2" />
                    )}
                    Labor
                  </span>
                </p>
                <Collapse isOpen={openSections.includes("labor")}>
                  <React.Fragment>
                    <hr className="my-1" />
                    <div className="form-row form-group mb-2">
                      <div className="col">
                        <button
                          type="button"
                          name="getLwpCsv"
                          id="getLwpCsv"
                          className="btn btn-secondary"
                          onClick={this.handleClick_csv("labor")}
                        >
                          <FontAwesomeIcon icon="download" className="fa-fw mr-2" />
                          Download as CSV
                        </button>
                      </div>
                    </div>
                    <div className="report-table-container border">
                      <Table
                        className="table table-sm table-hover"
                        columns={lwpColumns}
                        data={lwpData}
                        idPropName={"laborId"}
                        idPropName2={"workPerformedId"}
                        sortColumn={lwpSortColumn}
                        onSort={this.handleSort_lwp}
                        handleClick_tr={this.handleClick_tr_lwp}
                      />
                    </div>
                  </React.Fragment>
                </Collapse>
              </div>
            </div>
            <div className="card mb-2">
              <div className="card-body">
                <p className="h4 mb-0">
                  <span onClick={this.toggleSection("equip")} className="pointer-cursor">
                    {openSections.includes("equip") ? (
                      <FontAwesomeIcon icon="caret-down" className="fa-fw mr-2" />
                    ) : (
                      <FontAwesomeIcon icon="caret-right" className="fa-fw mr-2" />
                    )}
                    Equipment
                  </span>
                </p>
                <Collapse isOpen={openSections.includes("equip")}>
                  <React.Fragment>
                    <hr className="my-1" />
                    <div className="form-row form-group mb-2">
                      <div className="col">
                        <button
                          type="button"
                          name="getEwpCsv"
                          id="getEwpCsv"
                          className="btn btn-secondary"
                          onClick={this.handleClick_csv("equip")}
                        >
                          <FontAwesomeIcon icon="download" className="fa-fw mr-2" />
                          Download as CSV
                        </button>
                      </div>
                    </div>
                    <div className="report-table-container border">
                      <Table
                        className="table table-sm table-hover"
                        columns={ewpColumns}
                        data={ewpData}
                        idPropName={"equipmentId"}
                        idPropName2={"workPerformedId"}
                        sortColumn={ewpSortColumn}
                        onSort={this.handleSort_ewp}
                        handleClick_tr={this.handleClick_tr_ewp}
                      />
                    </div>
                  </React.Fragment>
                </Collapse>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  report: state.reports.openReports[ownProps.tab.tabId],
  feederLists: state.feederLists[ownProps.tab.projectId],
  projItemList: state.bidItems.projItemLists[ownProps.tab.projectId] || null,
  projCcoList: state.ccos.projCcoLists[ownProps.tab.projectId] || null,
  projPendingIssueList:
    state.pendingIssues.projPendingIssueLists[ownProps.tab.projectId] || null,
  projContractorList:
    state.contractors.projContractorLists[ownProps.tab.projectId] || null,
  projLaborList: state.labors.projLaborLists[ownProps.tab.projectId] || null,
  projEquipList: state.equipment.projEquipLists[ownProps.tab.projectId] || null,
  fetching:
    state.reports.fetching ||
    state.feederLists.fetching ||
    state.locations.fetching ||
    state.keywords.fetching ||
    state.bidItems.fetching ||
    state.ccos.fetching ||
    state.contractors.fetching ||
    state.labors.fetching ||
    state.equipment.fetching ||
    state.projects.fetching,
});

export default connect(mapStateToProps)(WorkPerformedReport);
